import axios from "../service/axios/axios";

export default {
  // 医生信息列表
  doctorList(data) {
    return axios({
      method: "post",
      url: "platform/doctor/doctorList",
      data: data,
    });
  },
  // 设置测试医生
  setTestDoctor({ doctor_id, status }) {
    return axios({
      method: "post",
      url: "platform/doctor/setTestDoctor",
      data: {
        doctor_id,
        status,
      },
    });
  },
  //添加医生
  addDoctor(addData) {
    return axios({
      method: "post",
      url: "platform/doctor/save",
      data: addData,
    });
  },
  //删除医生
  delDoctor({ doctor_id }) {
    return axios({
      method: "post",
      url: "platform/doctor/delete",
      data: {
        doctor_id,
      },
    });
  },
  //医生解锁/锁定  1解锁，0锁定
  updateDoctorStatus({ doctor_id, status }) {
    return axios({
      method: "post",
      url: "platform/doctor/updateDoctorStatus",
      data: {
        doctor_id,
        status,
      },
    });
  },
  //申请认证
  saveAuthentication(data) {
    return axios({
      method: "post",
      url: "platform/doctor/saveAuthentication",
      data: data,
    });
  },
  //修改认证
  updateDoctorAuthInfo(data) {
    return axios({
      method: "post",
      url: "platform/doctor/updateDoctorAuthInfo",
      data: data,
    });
  },
  //查看审核认证详情
  licenseDoctorItem({ reviewed_id }) {
    return axios({
      method: "post",
      url: "platform/doctor/licenseDoctorItem",
      data: {
        reviewed_id,
      },
    });
  },
  //医生擅长列表
  getDoctorBeGoodsAt(data) {
    return axios({
      method: "post",
      url: "platform/doctor/getDoctorBeGoodsAt",
      data,
    });
  },
  //科室列表
  getDepartmentList() {
    return axios({
      method: "post",
      url: "platform/doctor/getDepartmentList",
    });
  },

  // 医生详情
  doctorDetail({ doctor_id }) {
    return axios({
      method: "post",
      url: "platform/doctor/doctorItem",
      data: {
        doctor_id,
      },
    });
  },
  //审核认证列表
  doctorAuthList(data) {
    return axios({
      method: "post",
      url: "platform/doctor/doctorAuthList",
      data: data,
    });
  },
  //医生审核认证 3通过，4不通过
  auditDoctor(data) {
    return axios({
      method: "post",
      url: "platform/doctor/auditDoctor",
      data,
    });
  },
  //审核视频列表
  videoAuthList(data) {
    return axios({
      method: "post",
      url: "platform/doctor/videoAuthList",
      data: data,
    });
  },
  //视频审核 2通过，3不通过
  auditVideo({ doctor_id, auth_status }) {
    return axios({
      method: "post",
      url: "platform/doctor/auditVideo",
      data: {
        doctor_id,
        auth_status,
      },
    });
  },
  //提交医生视频
  submitDoctorVideo(data) {
    return axios({
      method: "post",
      url: "platform/doctor/submitDoctorVideo",
      data: data,
    });
  },
  //删除医生视频
  deleteVideo({ doctor_id }) {
    return axios({
      method: "post",
      url: "platform/doctor/deleteVideo",
      data: {
        doctor_id,
      },
    });
  },
  //修改姓名/性别
  modify(data) {
    return axios({
      method: "post",
      url: "platform/doctor/modify",
      data: data,
    });
  },
  /***  医生列表 **/
  setOpenDisturb(data) {
    return axios({
      method: "post",
      url: "platform/doctor/setOpenDisturb",
      data: data,
    });
  },
  // 医生设置是否在平台能搜到
  setIsOpen(data) {
    return axios({
      method: "post",
      url: "platform/doctor/setIsOpen",
      data: data,
    });
  },
  // 医生设置患者是否可以切换药房
  setChangeHospital(data) {
    return axios({
      method: "post",
      url: "platform/doctor/setChangeHospital",
      data: data,
    });
  },
  // 开方后药材保密设置
  setIsShow(data) {
    return axios({
      method: "post",
      url: "platform/doctor/setIsShow",
      data: data,
    });
  },
  // 自动复诊设置
  setIsPreConsultNotice(data) {
    return axios({
      method: "post",
      url: "platform/doctor/setIsPreConsultNotice",
      data: data,
    });
  },
  // 推送随访单设置
  setIsPreVisitNotice(data) {
    return axios({
      method: "post",
      url: "platform/doctor/setIsPreVisitNotice",
      data: data,
    });
  },
  // 邀请患者后自动复诊提醒设置
  setIsFavConsultNotice(data) {
    return axios({
      method: "post",
      url: "platform/doctor/setIsFavConsultNotice",
      data: data,
    });
  },
  // 医生设置是否带入上次处方
  setIsPrevPre(data) {
    return axios({
      method: "post",
      url: "platform/doctor/setIsPrevPre",
      data: data,
    });
  },
  // 设置是否开启极速问诊
  setFastConsult(data) {
    return axios({
      method: "post",
      url: "platform/doctor/setFastConsult",
      data: data,
    });
  },
  // 设置非复诊患者不可咨询
  setFollowConsultation(data) {
    return axios({
      method: "post",
      url: "platform/doctor/setFollowConsultation",
      data: data,
    });
  },
  // 设置新标药材剂量修改确认弹框是否开启
  setNationalStandard(data) {
    return axios({
      method: "post",
      url: "platform/doctor/setNationalStandard",
      data: data,
    });
  },
  /***  未入驻医生  ***/
  // 未入驻医生列表
  getDoctorHouseList(data) {
    return axios({
      method: "post",
      url: "platform/Doctor/getDoctorHouseList",
      data: data,
    });
  },
  // 未入驻医生 推荐详情
  getDoctorHouseRecommendList(data) {
    return axios({
      method: "post",
      url: "platform/Doctor/getDoctorHouseRecommendList",
      data: data,
    });
  },
  // 删除未入驻医生
  deleteDoctorHouse(data) {
    return axios({
      method: "post",
      url: "platform/Doctor/deleteDoctorHouse",
      data: data,
    });
  },
  // 设置是否可搜索
  setDoctorHouseShow(data) {
    return axios({
      method: "post",
      url: "platform/Doctor/setDoctorHouseShow",
      data: data,
    });
  },
  // 未入驻医生详情
  getDoctorHouseInfo(data) {
    return axios({
      method: "post",
      url: "platform/Doctor/getDoctorHouseInfo",
      data: data,
    });
  },
  // 新增未入驻医生
  addDoctorHouse(data) {
    return axios({
      method: "post",
      url: "platform/Doctor/addDoctorHouse",
      data: data,
    });
  },
  // 编辑未入驻医生
  updateDoctorHouse(data) {
    return axios({
      method: "post",
      url: "platform/Doctor/updateDoctorHouse",
      data: data,
    });
  },
  /***  未入驻医生---end  ***/
  // 绑定记录
  getRecommenderLog(data) {
    return axios({
      method: "post",
      url: "platform/Doctor/getRecommenderLog",
      data: data,
    });
  },
  /***  注销列表(医)---start  ***/
  // 标记医生注销
  remarkDoctorCancel(data) {
    return axios({
      method: "post",
      url: "platform/doctor/remarkDoctorCancel",
      data: data,
    });
  },
  /***  注销列表(医)---end  ***/
  /***  医生评价---start  ***/
  // 医生评价审核列表
  getUserEvaluateLog(data) {
    return axios({
      method: "post",
      url: "platform/doctor/getUserEvaluateLog",
      data: data,
    });
  },
  /***  医生评价---end  ***/
  /***  备案管理---start  ***/
  // 上传资产
  submitDoctorRecordReviewed(data) {
    return axios({
      method: "post",
      url: "platform/doctor/submitDoctorRecordReviewed",
      data: data,
    });
  },
  /***  备案管理---end  ***/
};
